<template>
  <div>
    <label v-if="!hideLabels">{{ label || $t('questionForm.email.title') }}</label>
    <v-text-field
      id="email"
      flat
      solo
      :class="{ 'is-valid': !disabled && $v.email.$dirty && !$v.email.$invalid && !emailError }"
      :disabled="disabled"
      :error="!disabled && $v.email.$error && emailError"
      :error-messages="emailErrorMessage"
      :messages="helpText"
      :placeholder="
        showPlaceholder ? (placeholder ? placeholder : $t('questionForm.email.placeholder')) : ''
      "
      :value="email"
      hide-details="auto"
      @focus="sendGtmEvent('E-mail')"
      @input="
        email = $event.toLowerCase();
        $emit('clearEmailError');
      "
      @keyup="$emit('keyup', $event)"
      @blur="$v.email.$dirty || email.length ? $v.email.$touch() : null"
    >
      <template v-if="!disabled" #append>
        <v-icon v-if="$v.email.$dirty && !$v.email.$error && !emailError">$tick</v-icon>
        <v-icon v-if="$v.email.$error">$warning</v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import formValidation from '@/mixins/formValidation';
import formGtm from '@/mixins/formGtm';

export default {
  name: 'Email',
  mixins: [formValidation, formGtm],
  props: {
    hideLabels: {
      type: Boolean,
      default: false
    },
    showHelpText: {
      type: Boolean,
      default: true
    },
    showPlaceholder: {
      type: Boolean,
      default: false
    },
    emailError: {
      type: Boolean,
      default: false
    },
    emailHelpText: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: false
    },
    requiredInput: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  validations() {
    if (this.disabled) {
      return { email: {} };
    }
    if (this.requiredInput) {
      return {
        email: { required, email }
      };
    } else {
      return {
        email: { email }
      };
    }
  },
  computed: {
    email: {
      get() {
        return this.$store.state.forms.email.email;
      },
      set(value) {
        this.$store.commit('forms/email/updateEmail', value);
      }
    },
    emailErrorMessage() {
      if (!this.$v.email) {
        return '';
      }
      if (this.$v.email.$error && this.$v.email.$invalid && this.$v.email.required) {
        return this.$t('questionForm.email.errorEmailText');
      } else if (this.emailError) {
        return this.$t('questionForm.email.errorEmailNotExisting');
      } else if (this.$v.email.$error && !this.$v.email.required) {
        return this.$t('questionForm.email.errorText');
      }
      return '';
    },
    helpText() {
      if (!this.showHelpText) {
        return null;
      }

      return this.emailHelpText ? this.emailHelpText : this.$t('questionForm.email.helpText');
    }
  },
  created() {
    this.$eventHub.$on('validateEmail', done => this.validateForm(done, 'forms/email'));
    this.$v.$reset();
    if (this.value) {
      this.email = this.value;
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('validateEmail');
  }
};
</script>
